const passwordOutcome = (password, confirmPassword) => {
  return [
    {
      message: 'Password matches confirmation',
      invalid: password.length === 0 || password !== confirmPassword
    },
    {
      message: 'At least 6 characters',
      invalid: password.length < 6
    },
    {
      message: 'At least 1 uppercase letter',
      invalid: password === password.toLowerCase()
    },
    {
      message: 'At least 1 lowercase letter',
      invalid: password === password.toUpperCase()
    },
    {
      message: 'At least 1 number',
      invalid: !/\d/.test(password)
    }
  ]
}

export default passwordOutcome
